             
<template>
    <b-card :title="'Firmante: #'+(index+1)" class="mb-1">
        <b-row>
            <b-col>
                <b-row>
                    <b-col cols="9">
                        <b-form-group v-show="firmante.editardatos"
                            class="mb-4"
                            label-cols-lg="2"
                            
                            label-class="font-weight-bold pt-0"
                            label="Datos del firmante"
                        >
                            <b-input-group prepend="Email" class="mb-2">                
                                <b-form-input type="text" required
                                    placeholder = "Indica el email"
                                    aria-label="Email"
                                    v-model="firmante.email"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Nombre" class="mb-2">                
                                <b-form-input type="text" required
                                    placeholder = "Indica el nombre"
                                    aria-label="Nombre"
                                    v-model="firmante.nombre"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Línea #1" class="mb-2"
                                    description = "(Opcional) Texto bajo la firma">                
                                <b-form-input type="text"
                                    placeholder = "Indica el cargo"
                                    aria-label="Línea #1"
                                    v-model="firmante.cargo"></b-form-input>
                            </b-input-group>
                            <b-input-group prepend="Línea #2" class="mb-2"
                                    description = "(Opcional) Texto bajo el del cargo">                
                                <b-form-input type="text"
                                    placeholder = "Indica en representación de qué firma"
                                    aria-label="Línea #2"
                                    v-model="firmante.representacion"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group
                            label-cols-lg="2"
                            label="Modalidad de firma"
                            
                            label-class="font-weight-bold pt-0"
                            class="mb-4"
                            description="(*) Firma con certificado digital especial: Si se indica en la opción, en el documento (junto a los datos del firmante) se fijará una imagen que incluye el sello de la empresa indicada y, en algunos casos, también la rúbrica de la persona"
                            >
                            
                            <b-form-radio-group
                                :name="'chk-modalidadfirma-'+firmante.id"
                                :id="'chk-modalidadfirma-'+firmante.id"
                                v-model="firmante.modalidadfirma"
                                :options="modalidadesdefirma"
                                value-field="item"
                                text-field="item.descripcion"
                                stacked
                                @change="onSeleccionModalidadFirma"
                            ></b-form-radio-group>
                            
                            <!-- <b-form-radio-group>
                                <b-form-radio v-model="firmante.modalidadfirma" :name="'chk-modalidadfirma-'+firmante.id"
                                    v-for="mf in firmante.modalidadesdefirma" :key="mf.id" :value="mf"
                                    @change="onSeleccionModalidadFirma">{{mf.descripcion}}</b-form-radio>
                            </b-form-radio-group> -->
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <div class="p-2 text-center rounded" style="font-size:.85em; background-color:snow">
                            <div class="font-weight-bold">{{ firmante.nombre }}</div>
                            {{ firmante.cargo }}<br />
                            {{ firmante.representacion }}<br />
                        </div>
                    </b-col>
                </b-row>
                <b-form-group
                    class="mb-4"
                    label-cols-lg="2"
                    
                    label-class="font-weight-bold pt-0"
                    label="Mensaje privado"
                    label-for="textarea-cuerpodelcorreo"
                    description="Este texto se enviará por email a parte y tiene como objetivo explicar/resumir el documento asociado a firmar. Si se deja en blanco, no se enviará ningún mensaje privado a esta persona."
                >
                    <b-form-textarea
                        :id="firmante.id+'textarea-mensajeprivado'"
                        v-model="firmante.mensajeprivado"
                        placeholder="(Opcional) Introduce aquí el mensaje personalizado que deseas enviar a esta persona"
                        rows="3"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>                        
            <b-col cols="1" class="text-center">
                <b-form-checkbox v-model="firmante.editardatos" :id="firmante.id+'chk-editardatos'" name="check-editardatos" switch>
                    <b-icon-pencil-square></b-icon-pencil-square>
                </b-form-checkbox>
            </b-col>
        </b-row>
        <!-- <b-form-group
            v-if="firmante.modalidadfirma==='MN'"
            >
            pagina:
            posicion x:
            posicion y:
            Incluir nombre del firmante a pie de firma
        </b-form-group> -->
    </b-card>
</template>                


<script>
    export default {
        props: {
            firmante: {
                type: Object,
                default: null
            },
            index: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                editardatos: false,
                id: 0,
                email: "",
                nombre: "",
                cargo: "",
                representacion: "",
                modalidadfirma: "",
                modalidadesdefirma: [],
                mensajeprivado: ""
            }
        },
        mounted () {
            //this.firmante.modalidadfirma = this.firmante.modalidadesdefirma[0]
            this.firmante.modalidadesdefirma.forEach(mdf => {
                this.modalidadesdefirma.push({ "item": mdf })
            })
            
            console.log(this.firmante.modalidadfirma)
            // this.id = this.firmante.id;
            // this.email = this.firmante.email;
            // this.nombre = this.firmante.nombre;
            // this.cargo = this.firmante.cargo;
            // this.representacion = this.firmante.representacion;
            // this.modalidadfirma = this.firmante.modalidadfirma;
            // this.modalidadesdefirma = this.firmante.modalidadesdefirma;
            // this.mensajeprivado = this.firmante.mensajeprivado;
            // this.editardatos = this.firmante.editardatos;
        },
        methods: {
            onSeleccionModalidadFirma(checked) {
                if (checked.representacion.length) this.firmante.representacion = checked.representacion
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>